@let formatValue = format();
@if (formatValue !== MangaFormat.UNKNOWN) {
  @if (useTitle()) {
    <i class="{{formatValue | mangaFormatIcon}}" aria-hidden="true" title="{{formatValue | mangaFormat}}"></i>
  } @else {
    <i class="{{formatValue | mangaFormatIcon}}" aria-hidden="true" ngbTooltip="{{formatValue | mangaFormat}}"></i>
  }
  <ng-content />
}
